var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390 390",
    style: {
      enableBackground: "new 0 0 390 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1446_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1447_",
    x: 30,
    y: 175,
    style: {
      fill: "#FF5023"
    },
    width: 60,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1448_",
    x: 30,
    y: 105,
    style: {
      fill: "#FF9811"
    },
    width: 60,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1449_",
    x: 30,
    y: 35,
    style: {
      fill: "#FFDA44"
    },
    width: 60,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1450_",
    x: 120,
    y: 245.002,
    style: {
      fill: "#FF5023"
    },
    width: 60,
    height: 69.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1451_",
    x: 120,
    y: 145,
    style: {
      fill: "#FF9811"
    },
    width: 60,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1452_",
    x: 120,
    y: 75,
    style: {
      fill: "#FFDA44"
    },
    width: 60,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1453_",
    x: 210,
    y: 215,
    style: {
      fill: "#FF5023"
    },
    width: 60,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1454_",
    x: 210,
    y: 105,
    style: {
      fill: "#FF9811"
    },
    width: 60,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1455_",
    x: 210,
    y: 35,
    style: {
      fill: "#FFDA44"
    },
    width: 60,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1456_",
    x: 300,
    y: 245.002,
    style: {
      fill: "#FF5023"
    },
    width: 60,
    height: 69.998
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1457_",
    x: 300,
    y: 175,
    style: {
      fill: "#FF9811"
    },
    width: 60,
    height: 70
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1458_",
    x: 300,
    y: 75.002,
    style: {
      fill: "#FFDA44"
    },
    width: 60,
    height: 99.998
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1459_",
    style: {
      fill: "#CDCDD0"
    },
    points: "180,315 120,315 90,315 30,315 0,315 0,355 195,355 195,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1460_",
    style: {
      fill: "#ACABB1"
    },
    points: "360,315 300,315 270,315 210,315 195,315 195,355 390,355 390,315  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chart_icon.37b2a0b1ed432e35472ccd5258899e38.svg";
export { ForwardRef as ReactComponent };